import gql from "graphql-tag";

export const GET_ORDER_DETAIL = gql`
query orderDetails($orderId:uuid!){
  orderDetails(where: {orderId: {_eq: $orderId}}) {
    id
    lrObject
    orderId
    orderReadiness
    pickupConfirmation
    pickupPoint
  }
}
`
export const GET_ORDER_DETAIL_FOR_VEHICLE = gql`
query orderDetails($orderId:uuid!){
  orderDetails(where: {orderId: {_eq: $orderId}}) {
    id
    pickupVehicleAssignId
    PIckupTempo{
        id 
      tempo {id name } 
      driverDetail {id name }
     }
    PickupTruck{
      id   
      truck {id name } 
      driverDetail {id name }
     }
    transportVehicleAssignId
    truckOrder{
     id    
     truck {id name } 
     driverDetail {id name }
    }
  }
}
`

export const GET_BREAKAGE_HISTORY = gql`
query orderDetails($orderId:uuid!){
  orderDetails(where: {orderId: {_eq: $orderId}}) {
    id
    dispactchVerification
  }
}
`
